import { render } from "./SubmissionSingle.vue?vue&type=template&id=10aee366"
import script from "./SubmissionSingle.vue?vue&type=script&lang=js"
export * from "./SubmissionSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__